export default [{
    path: 'monitoringOverview',
    redirect: '/monitoringOverview/index',
    children: [{
        path: '/monitoringOverview/index',
        meta: {
            title: "首页概览",
            name: 'index',
            keepAlive: true
        },
        components: {
            mains: () => import('../views/onitorOverview/index.vue')
        }
    } ]
}]